document.addEventListener('DOMContentLoaded', () => {
  if (document.documentElement.dataset.seasonalTrendsReady === 'true') return;
  document.documentElement.dataset.seasonalTrendsReady = 'true';

  const trendPage = document.querySelector('[data-nail-trending-page]');
  const customerId = trendPage?.dataset.customerId?.trim();
  const customerName = trendPage?.dataset.customerName?.trim();
  const customerEmail = trendPage?.dataset.customerEmail?.trim();
  const apiBaseUrl = `${window.location.protocol === 'https:' ? 'https' : 'http'}://informationcollection.benyuan1.com/api/trendFavorite`;
  const favoriteTrendIds = new Set();

  const getTrendButtons = (trendId) => [...document.querySelectorAll('[data-seasonal-trends-save]')]
    .filter((button) => button.dataset.trendId === trendId);

  const setFavoriteState = (trendId, isFavorited) => {
    getTrendButtons(trendId).forEach((button) => {
      button.setAttribute('aria-pressed', String(isFavorited));
    });
    if (isFavorited) favoriteTrendIds.add(trendId);
    else favoriteTrendIds.delete(trendId);
  };

  const setFavoritePending = (trendId, isPending) => {
    getTrendButtons(trendId).forEach((button) => {
      button.disabled = isPending;
      button.setAttribute('aria-busy', String(isPending));
    });
  };

  const postFavoriteRequest = async (path, payload) => {
    const response = await fetch(`${apiBaseUrl}/${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const result = await response.json().catch(() => null);
    const apiResult = result?.data && typeof result.data === 'object' && 'success' in result.data
      ? result.data
      : result;
    const isSuccess = apiResult?.success === true || result?.status === 'success';
    if (!response.ok || !isSuccess) {
      throw new Error(apiResult?.message || result?.message || `Trend favorite request failed (${response.status})`);
    }
    return apiResult;
  };

  const loadFavoriteStates = async () => {
    if (!trendPage || !customerId) return;
    try {
      const result = await postFavoriteRequest('list', {
        user_id: customerId,
        category: 'all',
        type: 1,
      });
      (Array.isArray(result.data) ? result.data : []).forEach((item) => {
        if (item?.trend_id != null) favoriteTrendIds.add(String(item.trend_id));
      });
      favoriteTrendIds.forEach((trendId) => setFavoriteState(trendId, true));
    } catch (error) {
      console.warn('Unable to load trend favorite states.', error);
    }
  };

  document.querySelectorAll('[data-seasonal-trends]').forEach((section) => {
    const track = section.querySelector('[data-seasonal-trends-track]');
    const previous = section.querySelector('[data-seasonal-trends-previous]');
    const next = section.querySelector('[data-seasonal-trends-next]');
    const dots = [...section.querySelectorAll('[data-seasonal-trends-dot]')];

    if (!track) return;

    const step = () => {
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap) || Number.parseFloat(styles.gap) || 0;
      return track.querySelector('.seasonal-trends__card')?.getBoundingClientRect().width + gap || 175.5;
    };
    const cardsPerPage = () => window.matchMedia('(max-width: 768px)').matches ? 2 : 1;
    const updateNavigation = () => {
      const maxScrollLeft = track.scrollWidth - track.clientWidth;
      if (previous) previous.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= maxScrollLeft - 1;

      const media = track.querySelector('.seasonal-trends__media');
      if (media) {
        const carouselTop = track.getBoundingClientRect().top;
        const mediaBounds = media.getBoundingClientRect();
        section.style.setProperty(
          '--seasonal-trends-nav-top',
          `${mediaBounds.top - carouselTop + mediaBounds.height / 2}px`,
        );
      }
    };
    const updateDots = () => {
      if (!dots.length) return;
      const index = Math.min(dots.length - 1, Math.round(track.scrollLeft / (step() * cardsPerPage())));
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === index)));
    };

    previous?.addEventListener('click', () => track.scrollBy({ left: -step() * cardsPerPage(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step() * cardsPerPage(), behavior: 'smooth' }));
    dots.forEach((dot) => dot.addEventListener('click', () => track.scrollTo({ left: Number(dot.dataset.seasonalTrendsDot) * step() * cardsPerPage(), behavior: 'smooth' })));
    track.addEventListener('scroll', () => {
      updateDots();
      updateNavigation();
    }, { passive: true });
    window.addEventListener('resize', updateNavigation);
    updateNavigation();

  });

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element
      ? event.target.closest('[data-seasonal-trends-save]')
      : null;
    if (!(button instanceof HTMLButtonElement)) return;

    const authSection = button.closest('[data-seasonal-trends-auth]')
      || document.querySelector('[data-seasonal-trends-auth]');
    if (authSection?.dataset.customerLoggedIn !== 'true') {
      authSection?.__likeShareAuth?.setTab?.('login');
      authSection?.__likeShareAuth?.openModal?.();
      return;
    }

    if (!trendPage || !customerId) {
      button.setAttribute('aria-pressed', String(button.getAttribute('aria-pressed') !== 'true'));
      return;
    }

    const trendId = button.dataset.trendId;
    const category = button.dataset.trendCategory;
    if (!trendId || !category || button.disabled) return;

    const isFavorited = favoriteTrendIds.has(trendId);
    const countDelta = isFavorited ? -1 : 1;
    setFavoritePending(trendId, true);
    setFavoriteState(trendId, !isFavorited);
    window.TrendFavoriteCounts?.adjust(trendId, countDelta);
    postFavoriteRequest(isFavorited ? 'unfavorite' : 'favorite', {
      user_id: customerId,
      user_name: customerName,
      email: customerEmail,
      trend_id: trendId,
      ...(isFavorited ? {} : { category, title: button.dataset.trendTitle }),
      type: 1,
    })
      .then(() => window.TrendFavoriteCounts?.refreshTrend(trendId))
      .catch((error) => {
        setFavoriteState(trendId, isFavorited);
        window.TrendFavoriteCounts?.adjust(trendId, -countDelta);
        console.warn('Unable to update trend favorite.', error);
      })
      .finally(() => setFavoritePending(trendId, false));
  });

  loadFavoriteStates();
  window.TrendFavoriteCounts?.refresh();
});
